import styles from "./dialog.module.scss";

export const Alert = ({
  size = "medium",
  theme = "yellow500",
  content = "",
  marginForCustom = "",
  textAlign = "center",
  onClick,
  isBold,
}: {
  size?: "large" | "medium" | "small";
  theme?: "yellow500" | "blue500";
  content?: string | React.ReactNode;
  marginForCustom?: string; // 위치 조정
  textAlign?: "left" | "center" | "right";
  onClick?: () => void;
  isBold?: boolean;
}) => {
  return content ? (
    <div
      className={`${styles["dialog--alert"]} ${styles[`alert-${size}`]} ${styles[`alert-${theme}`]} ${isBold ? styles["bold"] : ""}`}
      style={{
        margin: marginForCustom,
        textAlign: textAlign,
      }}
      onClick={() => {
        onClick && onClick();
      }}
    >
      {content}
    </div>
  ) : null;
};
